import { policyTipsOverrideLink } from '../strings.locstring.json';
import {
    policyTipsOverrideJustificationErrorMessage,
    policyTipsOverrideJustificationDescription,
    policyTipsOverrideJustificationRadioButtonReasonLabel,
    policyTipsOverrideJustificationReasonTextboxPlaceholder,
    policyTipsOverrideJustificationRadioButtonFalsePositiveLabel,
} from './PolicyTipsOverrideDialog.locstring.json';
import { cancelButton } from 'owa-locstrings/lib/strings/cancelbutton.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { Dialog, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { OwaModalProps } from 'owa-modal';

import * as React from 'react';

export interface PolicyTipsOverrideInformation {
    isFalsePositive: boolean;
    justification: string;
}

export type PolicyTipsOverrideDialogProps = OwaModalProps<PolicyTipsOverrideInformation>;

export default observer(function PolicyTipsOverrideDialog(props: PolicyTipsOverrideDialogProps) {
    const [isFalsePositive, setIsFalsePositive] = React.useState(false);
    const [justification, setJustification] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState(null);

    const validateAndDismiss = React.useCallback(() => {
        if (isFalsePositive || (justification && justification.length > 0)) {
            const currentValues: PolicyTipsOverrideInformation = {
                justification: justification,
                isFalsePositive: isFalsePositive,
            };
            props.onDismiss(currentValues);
        } else {
            setErrorMessage(loc(policyTipsOverrideJustificationErrorMessage));
        }
    }, [isFalsePositive, justification, props.onDismiss]);

    const dismissEmpty = React.useCallback(() => {
        props.onDismiss(null);
    }, [props.onDismiss]);

    const onSelectionChange = React.useCallback((ev, option) => {
        setIsFalsePositive(option.key == 'FalsePositive');
    }, []);

    const onJustificationChange = React.useCallback((ev, value) => {
        setJustification(value);
        setErrorMessage(null);
    }, []);

    return (
        <Dialog
            hidden={false}
            onDismiss={dismissEmpty}
            subText={loc(policyTipsOverrideJustificationDescription)}>
            <ChoiceGroup
                defaultSelectedKey="Override"
                onChange={onSelectionChange}
                options={[
                    {
                        key: 'Override',
                        text: loc(policyTipsOverrideJustificationRadioButtonReasonLabel),
                        onRenderField: (props, render) => {
                            return (
                                <div>
                                    {render(props)}
                                    <TextField
                                        onChange={onJustificationChange}
                                        errorMessage={errorMessage}
                                        placeholder={loc(
                                            policyTipsOverrideJustificationReasonTextboxPlaceholder
                                        )}
                                    />
                                </div>
                            );
                        },
                    },
                    {
                        key: 'FalsePositive',
                        text: loc(policyTipsOverrideJustificationRadioButtonFalsePositiveLabel),
                    },
                ]}
            />
            <DialogFooter>
                <PrimaryButton onClick={validateAndDismiss}>
                    {loc(policyTipsOverrideLink)}
                </PrimaryButton>
                <DefaultButton onClick={dismissEmpty}>{loc(cancelButton)}</DefaultButton>}
            </DialogFooter>
        </Dialog>
    );
});
